module.exports = __webpack_public_path__ + "media/images/icon/icons8-Do Not Disturb-f392313496d8150833aca9980a99c0c9.png";